'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _queries = require('./queries.component');

var _queries2 = _interopRequireDefault(_queries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var queriesModule = _angular2.default.module('queries', [_angularUiRouter2.default]).component('queries', _queries2.default);

exports.default = queriesModule;


// WEBPACK FOOTER //
// ./client/app/common/reports/queries/queries.js